import React from 'react';

import {Link} from 'react-router-dom';
import {
    FaFacebookF,
    FaLinkedinIn,
    FaMedium,
    FaRedditAlien,
    FaTwitter,
    FaYoutube,
} from 'react-icons/fa6';
import PlatformConfigurator from '../0_configuration/PlatformConfigurator';

function Footer() {
    const logoClass = PlatformConfigurator.getLogoClass();
    return (
        <footer>
            <div className="wrapper">
                <div className="main_footer_wrapper">
                    <div className="footer_brand">
                        <Link className={`logo ${logoClass}`} to="/">Home</Link>
                        <p className="brand_description">Quantiacs is the platform for quantitative traders to develop and test algorithmic trading strategies.</p>
                    </div>

                    <div className="footer_links_container">
                        <div className="footer_column">
                            <div className="footer_heading">Platform</div>
                            <nav className="footer_menu">
                                <ul>
                                    <li><Link className="nav_link" to="/contest">Contests</Link></li>
                                    <li><Link className="nav_link" to="/leaderboard">Leaderboard</Link></li>
                                    <li><a className="nav_link" href="/documentation/en/user_guide/data.html">Data</a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="footer_column">
                            <div className="footer_heading">Resources</div>
                            <nav className="footer_menu">
                                <ul>
                                    <li><a className="nav_link" href="/documentation/en/">Docs</a></li>
                                    <li><a className="nav_link" href="/community">Community</a></li>
                                    <li><Link className="nav_link" to="/faq">FAQ</Link></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="footer_column">
                            <div className="footer_heading">Company</div>
                            <nav className="footer_menu">
                                <ul>
                                    <li><Link className="nav_link" to="/contacts">Contact</Link></li>
                                    <li><Link className="nav_link" to="/career">Careers</Link></li>
                                    <li><a className="nav_link" href={`${window.location.origin.toString()}/personalpage/login`}>My account</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>

                <div className="footer_bottom_wrapper">
                    <div className="footer_legal">
                        <a className="legal_link" href="/personalinfo">Privacy policy</a>
                        <a className="legal_link" href="/termsofuse">Terms and Conditions</a>
                        <a className="legal_link" href="/cookies">Cookies policy</a>
                        <a className="legal_link" href="https://legacy.quantiacs.com/Systems.aspx" target="_blank" rel="noopener noreferrer">Q1-Q14 Contests</a>
                    </div>

                    <div className="soc_button_wrapper">
                        <a rel="noopener noreferrer" title="Facebook" aria-label="Facebook" href="https://www.facebook.com/quantiacs/" target="_blank" className="soc_link">
                            <FaFacebookF />
                        </a>
                        <a rel="noopener noreferrer" title="Twitter" aria-label="Twitter" href="https://twitter.com/Quantiacs" target="_blank" className="soc_link">
                            <FaTwitter />
                        </a>
                        <a rel="noopener noreferrer" title="Linkedin" aria-label="Linkedin" href="https://www.linkedin.com/company/quantiacs" target="_blank" className="soc_link">
                            <FaLinkedinIn />
                        </a>
                        <a rel="noopener noreferrer" title="Youtube" aria-label="Youtube" href="https://www.youtube.com/channel/UChVK03CwYHSXwsBiPuSi9GA" target="_blank" className="soc_link">
                            <FaYoutube />
                        </a>
                        <a rel="noopener noreferrer" title="Medium" aria-label="Medium" href="https://quantiacs.medium.com/" target="_blank" className="soc_link">
                            <FaMedium />
                        </a>
                        <a rel="noopener noreferrer" title="Reddit" aria-label="Reddit" href="https://www.reddit.com/r/quantiacs/" target="_blank" className="soc_link">
                            <FaRedditAlien />
                        </a>
                    </div>

                    <span className="copywrite">
                        © {new Date().getFullYear()} Quantiacs LLC. All rights reserved.
                    </span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;;

